"use client"
import { trackDiscoverPageNavigation } from "@/lib/performance"

export function useTrackHomePageNavigation() {
  return trackDiscoverPageNavigation
}
